// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R7Ln","placeholdersHeader":"styles_placeholdersHeader__2CKbt","editorStyle":"styles_editorStyle__1NX7x","placeholdersBox":"styles_placeholdersBox__1_kzc"};